import type { ReactNode } from 'react';
import { cn } from '@tark/shared/lib';

type CoachPageHeaderProps = {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  meta?: ReactNode;
  action?: ReactNode;
  stats?: ReactNode;
  className?: string;
};

export default function CoachPageHeader({
  eyebrow: _eyebrow = 'Coach Studio',
  title,
  subtitle,
  meta,
  action,
  stats,
  className,
}: CoachPageHeaderProps) {
  return (
    <section className={cn('tk-page-header', className)}>
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div className="min-w-0 flex-1">
          <h1>{title}</h1>
          {meta ? <div className="mt-1 text-xs text-text-muted">{meta}</div> : null}
          {subtitle ? <p className="mt-1 max-w-3xl text-xs text-text-muted">{subtitle}</p> : null}
        </div>
        {action ? <div className="flex min-w-0 flex-wrap items-center gap-2">{action}</div> : null}
      </div>
      {stats ? <div className="tk-summary-line mt-4">{stats}</div> : null}
    </section>
  );
}
